import { inject, Injectable } from '@angular/core';

import { NAVIGATOR, ToastService, ToastType } from '@hglobal/fin-ui';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  readonly #toast = inject(ToastService);
  readonly #translate = inject(TranslateService);
  readonly #navigator = inject(NAVIGATOR);

  copy(text: string, successMessageKey = 'clipboard.copy.successMessage') {
    this.#navigator.clipboard.writeText(text).then(() => {
      this.#toast.show({
        type: ToastType.Success,
        message: this.#translate.instant(successMessageKey),
      });
    });
  }
}
